/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Extra_SetInputs */

const en_us2_workout_extra_set = /** @type {(inputs: Workout_Extra_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`extra set`)
};

const pt_br2_workout_extra_set = /** @type {(inputs: Workout_Extra_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`série extra`)
};

const es_419_workout_extra_set = /** @type {(inputs: Workout_Extra_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`serie extra`)
};

const pt_pt2_workout_extra_set = /** @type {(inputs: Workout_Extra_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`série extra`)
};

const fr_fr2_workout_extra_set = /** @type {(inputs: Workout_Extra_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`série en plus`)
};

const de_de2_workout_extra_set = /** @type {(inputs: Workout_Extra_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extrasatz`)
};

const it_it2_workout_extra_set = /** @type {(inputs: Workout_Extra_SetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`serie extra`)
};

/**
* | output |
* | --- |
* | "extra set" |
*
* @param {Workout_Extra_SetInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_extra_set = /** @type {((inputs?: Workout_Extra_SetInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Extra_SetInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_extra_set(inputs)
	if (locale === "es-419") return es_419_workout_extra_set(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_extra_set(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_extra_set(inputs)
	if (locale === "de-DE") return de_de2_workout_extra_set(inputs)
	if (locale === "it-IT") return it_it2_workout_extra_set(inputs)
	return en_us2_workout_extra_set(inputs)
});
export { workout_extra_set as "workout.extra_set" }